import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { Row, Col, Space, Spin } from "antd"
import Fb from "../../images/fb.png"
import Twitter from "../../images/twitter.png"
import Insta from "../../images/insta.png"
import Google from "../../images/google.png"
import MariLogo from "../../images/marijuana-svg.svg"
import { Link, navigate } from "gatsby"
const StyledSection = styled.div`
  padding: 1rem;

  h1 {
    font-size: 30px;
    color: #172315;
    font-weight: 700;
  }

  .ant-spin-spinning {
    margin: 8rem;
    overflow: hidden;
    padding: 2rem;
  }

  .line-bar {
    width: 100%;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.lightColor};
  }
  .prod-image {
    width: 100%;
    height: auto;
  }
  .prod-thumb {
    padding-right: 1rem;
    width: 80px;
    cursor: pointer;
  }
  .prod-thumb-col {
    margin-top: 6px;
  }
  .prod-price {
    font-size: 30px;
    line-height: 41px;
    color: #5a8d52;
    font-weight: 700;
  }
  .key {
    font-size: 16px;
    line-height: 16px;
    font-weight: 500;
    overflow: hidden;
  }
  .value {
    font-size: 16px;
    line-height: 36px;
    color: #5a8d52;
    font-weight: 500;
  }

  p {
    font-size: 16px;
    line-height: 26px;
    color: #172315;
    font-weight: 500;
  }
  .social-icons {
    width: 20px;
    margin-left: 15px;
    cursor: pointer;
  }
  .mari-logo {
    width: 30px;
    filter: invert(40%) sepia(17%) saturate(985%) hue-rotate(65deg)
      brightness(75%) contrast(92%);
  }
  .rating-key {
    font-size: 24px;
    line-height: 30px;
    color: #172315;
    font-weight: 600;
  }
  .rating-value {
    font-size: 16px;
    line-height: 30px;
    color: #a6a6a6;
    font-weight: 500;
  }
  .styled-button {
    height: 30px;
    width: 120px;
    border-radius: 2px;
    background-color: #5a8d52;
    color: #ffffff;
    font-size: 10px;
    border: none;
    cursor: pointer;
    font-weight: 600;
  }

  .styled-button1 {
    width: 220px;
    height: 54px;
    border-radius: 2px;
    background-color: #5a8d52;
    border: none;
    font-size: 18px;
    color: #ffffff;
    font-weight: 600;
    cursor: pointer;
  }
`

const ProductModal = ({ id, products }) => {
  const [product, setproduct] = useState({})
  const [loading, setloading] = useState(true)

  const navigateToOrderForm = () => {
    localStorage.setItem("prodName", product.name)
    navigate(`/order-form`)
  }

  useEffect(() => {
    const result = products.find(prod => prod.id === id)
    setproduct(result)
    setloading(false)
  }, [id])
  return (
    <StyledSection>
      {loading ? (
        <Row justify="center">
          <Spin size="large" />
        </Row>
      ) : (
        <Row gutter={48}>
          <Col sm={24} md={12}>
            <img
              src={product.images[0] ? product.images[0].src : null}
              alt="product"
              className="prod-image"
            />
          </Col>
          <Col sm={24} md={12}>
            <h1>{product.name}</h1>
            <Space>
              <span className="key">Availability:</span>
              <span className="value">{product.stock_status}</span>
            </Space>
            <p>{product.description.slice(29, -300)}</p>
            <div className="line-bar" style={{ marginBottom: "1rem" }} />
            <div>
              <Row align="middle">
                <span className="key">SKU:</span>
                <span style={{ marginLeft: "8px" }} className="value">
                  {product.sku}
                </span>
              </Row>
              <Row align="middle">
                <span className="key">Categories:</span>

                {product.categories
                  ? product.categories.map(item => (
                      <React.Fragment key={item.id}>
                        <span style={{ marginLeft: "8px" }} className="value">
                          {`${item.name},`}
                        </span>
                      </React.Fragment>
                    ))
                  : null}
              </Row>
            </div>
            <br />
            <Space>
              <span className="key">Share Link:</span>
              <Row>
                <Space>
                  <img alt="fb" src={Fb} className="social-icons" />
                  <img alt="insta" src={Insta} className="social-icons" />
                  <img alt="twitter" src={Twitter} className="social-icons" />
                  <img alt="google" src={Google} className="social-icons" />
                </Space>
              </Row>
            </Space>
            <br />
            <Row style={{ marginTop: "1rem" }} gutter={[16, 16]}>
              <Col>
                <img
                  src={MariLogo}
                  alt="marijuana-logo"
                  className="mari-logo"
                />
              </Col>
              <Col>
                <Space>
                  <span className="rating-key">{product.average_rating}</span>
                  <span className="rating-value">{`(${product.rating_count})`}</span>
                </Space>
              </Col>
            </Row>
            <Row style={{ marginTop: "2rem" }} gutter={[16, 16]}>
              <Col>
                <Space size="middle">
                  <Link to={`/product?${product.id}`}>
                    <button className="styled-button1">
                      Further Information
                    </button>
                  </Link>
                  <button
                    onClick={navigateToOrderForm}
                    className="styled-button1"
                  >
                    Reserve Now
                  </button>
                </Space>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </StyledSection>
  )
}

export default ProductModal
